import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SensorHistoryChartComponent } from './sensor-history-chart.component';
import {DxChartModule, DxDataGridModule} from 'devextreme-angular';
import {DxoValueAxisModule} from 'devextreme-angular/ui/nested';
import {GridTitleModule} from 'shared';



@NgModule({
  declarations: [SensorHistoryChartComponent],
  imports: [
    CommonModule,
    DxChartModule,
    DxoValueAxisModule,
    DxDataGridModule,
    GridTitleModule
  ],
  exports: [SensorHistoryChartComponent]
})
export class SensorHistoryChartModule { }
